import { __assign, __rest } from "tslib";
import React from "react";
import VeltCommentDialogSuggestionActionAccept from "./VeltCommentDialogSuggestionActionAccept/VeltCommentDialogSuggestionActionAccept";
import VeltCommentDialogSuggestionActionReject from "./VeltCommentDialogSuggestionActionReject/VeltCommentDialogSuggestionActionReject";
import { transformWireframeProps } from '../../../utils/propUtils';
;
var VeltCommentDialogSuggestionAction = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-comment-dialog-suggestion-action-wireframe", __assign({}, transformedProps), children));
};
VeltCommentDialogSuggestionAction.Accept = VeltCommentDialogSuggestionActionAccept;
VeltCommentDialogSuggestionAction.Reject = VeltCommentDialogSuggestionActionReject;
export default VeltCommentDialogSuggestionAction;
